<template lang="html">
  <div class="worker-wrapper">
    <workerList :params="params"></workerList>
  </div>
</template>

<script>
import workerList from './workList'

export default {
  props: {
    params: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    workerList
  }
}
</script>
